export default "__VITE_ASSET__e2fff588__"